import { LandingPageContentClient } from '@/features/landing-page/landing-page-content-client'
import type { ILandingRouteContentLogo } from '@/features/landing-page/helpers/landing-route-content'

type ILandingPageContentTheme = 'default' | 'light'

interface ILandingPageContentProps {
    theme?: ILandingPageContentTheme
    title?: string
    subtitle?: string
    titleClassName?: string
    gradientSrc?: string
    ctaLabel?: string
    ctaHref?: string
    secondaryCtaLabel?: string
    secondaryCtaHref?: string
    bottomLogos?: ILandingRouteContentLogo[]
    bottomLogoLabel?: string
    bottomTagline?: string
}

export const LandingPageContent = ({
    theme = 'default',
    title,
    subtitle,
    titleClassName,
    gradientSrc,
    ctaLabel,
    ctaHref,
    secondaryCtaLabel,
    secondaryCtaHref,
    bottomLogos,
    bottomLogoLabel,
    bottomTagline,
}: ILandingPageContentProps) => {
    return (
        <LandingPageContentClient
            titleText={title || 'Full Ads. Built by AI.\nFrom one sentence.'}
            subtitleText={
                subtitle ||
                'Paste your link. Superscale researches winning ads, generates insights, and produces ready-to launch ads.'
            }
            theme={theme}
            titleClassName={titleClassName}
            gradientSrc={gradientSrc}
            ctaLabel={ctaLabel}
            ctaHref={ctaHref}
            secondaryCtaLabel={secondaryCtaLabel}
            secondaryCtaHref={secondaryCtaHref}
            bottomLogos={bottomLogos}
            bottomLogoLabel={bottomLogoLabel}
            bottomTagline={bottomTagline}
        />
    )
}
